import type { PermissionType } from '@repo/api-codegen';
import { UserRole } from '@repo/common/enums/UserRole';
import type { IconNames } from '@repo/foundations';

export const ANALYTICS_EVENTS = {
	SEARCH_AI_PROMPT_CATEGORY_SUGGESTION_CLICK:
		'search/ai/category_suggestion/click',
	SEARCH_AI_PROMPT_CONCRETE_SUGGESTION_CLICK:
		'search/ai/concrete_suggestion/click',
} as const;

export interface PromptSuggestion {
	label: string;
	prompt: string;
	icon: IconNames;
	inputPrefill: string;
	requiredPermission?: {
		v1AllowedRoles: Array<UserRole>;
		v2Permission: PermissionType;
	};
}

export const PROMPT_SUGGESTIONS: Array<PromptSuggestion> = [
	{
		label: 'Ask',
		prompt: 'Ask',
		icon: 'questionMark',
		inputPrefill: 'What ',
	},
	{
		label: 'Suggest',
		prompt: 'Suggest',
		icon: 'sparkles',
		inputPrefill: 'Suggest ',
		requiredPermission: {
			v1AllowedRoles: [UserRole.ADMIN, UserRole.EDITOR],
			v2Permission: 'Resources.Create',
		},
	},
	{
		label: 'Document',
		prompt: 'Document',
		icon: 'pencil',
		inputPrefill: 'Generate ',
	},
	{
		label: 'Chart',
		prompt: 'Chart',
		icon: 'chartBar',
		inputPrefill: 'Chart ',
	},
	{
		label: 'Code',
		prompt: 'Code',
		icon: 'code',
		inputPrefill: 'Write a SQL query to ',
	},
	{
		label: 'Summarize',
		prompt: 'Summarize',
		icon: 'file',
		inputPrefill: 'Summarize ',
	},
];
